var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forkme"},[_c('Ribbon',{attrs:{"text":"Fork me on github","url":"https://github.com/zecka/image-colors-extractor","position":"top-right","color":"#2c3e50"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }